import { MobileActions } from "./types"
const { IS_MOBILE } = MobileActions

export const updateDevice = payload => ({
    type: IS_MOBILE,
    payload
})